import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBarSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 w-full bg-accent-gold z-50 shadow-md" data-id="element-220">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-center sm:justify-between text-white font-bold text-sm sm:text-base" data-id="element-221">
        <div className="text-center sm:text-left mb-2 sm:mb-0" data-id="element-222">
          ⚡ OFERTA DE LANZAMIENTO — Termina en: {formatTime(minutes)}:
          {formatTime(seconds)}{' '}
          <span className="hidden sm:inline" data-id="element-223">
            · Solo quedan 30 minutos al precio actual
          </span>
        </div>
        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="bg-white text-accent-gold px-4 py-1 rounded-full text-xs sm:text-sm hover:bg-gray-50 transition-colors whitespace-nowrap" data-id="element-224">
          OBTENERLO AHORA →
        </button>
      </div>
    </div>;
}